import { render } from "./MultiSelection.vue?vue&type=template&id=35c5ebdf&scoped=true"
import script from "./MultiSelection.vue?vue&type=script&lang=js"
export * from "./MultiSelection.vue?vue&type=script&lang=js"

import "./MultiSelection.vue?vue&type=style&index=0&id=35c5ebdf&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c5ebdf"]])

export default __exports__